import React from "react";
import Select from "@mui/material/Select";
import {headerStyle} from "../headerStyle";

interface CustomSelectFieldProps {
  labelId: string;
  id: string;
  outlet?: React.ReactNode;
  fullWidth?: boolean;
  style?: React.CSSProperties | undefined;
  size?: "small";
  defaultValue?: string | number;
  value?: string;
  onChange?: (event: any) => void;
}

const HeaderSelectComponent: React.FC<CustomSelectFieldProps> = ({
  labelId,
  id,
  outlet,
  fullWidth,
  defaultValue,
  onChange,
  value,
  size,
}) => {
  return (
    <Select
      labelId={labelId}
      id={id}
      onChange={onChange}
      style={headerStyle.selectStyle}
      defaultValue={defaultValue}
      fullWidth={fullWidth}
      value={value}
      size={size}
      sx={{
        "& .MuiSelect-select": {
          color: "#2C60C7",
        },
      }}>
      {outlet}
    </Select>
  );
};

export default HeaderSelectComponent;
